import Service from './Service';
import Constants from '../submodules/logictry_config/constants';
import Version from '../version.json';
import { mountUpdateRequiredPopup } from '../components/UpdateRequiredPopup';

function parseVersion(v) {
  return String(v || '').split('.').map((n) => parseInt(n, 10) || 0);
}

function compareVersions(a, b) {
  const pa = parseVersion(a);
  const pb = parseVersion(b);
  const len = Math.max(pa.length, pb.length);
  for (let i = 0; i < len; i += 1) {
    const d = (pa[i] || 0) - (pb[i] || 0);
    if (d !== 0) return d > 0 ? 1 : -1;
  }
  return 0;
}

let reloadStarted = false;

class VersionChecker extends Service {
  updateRequired = false;
  binaryBehind = false;

  constructor() {
    super();
    mountUpdateRequiredPopup(this);
    if (Constants.isIphone) {
      this._binaryCheck = this.readBinaryRequirement().then((behind) => {
        this.binaryBehind = !!behind;
        if (!this.binaryBehind) return false;
        this.updateRequired = true;
        this.emitStateUpdate();
        return true;
      });
    }
  }

  reloadForNewVersion() {
    if (reloadStarted) return;
    if (sessionStorage.getItem('logictry_version_reload')) {
      this.updateRequired = true;
      this.emitStateUpdate();
      return;
    }
    reloadStarted = true;
    sessionStorage.setItem('logictry_version_reload', 'true');
    window.location.reload();
  }

  binaryIsBehind() {
    if (!Constants.isIphone) return Promise.resolve(false);
    return this._binaryCheck || Promise.resolve(false);
  }

  async installedBinaryVersion() {
    try {
      const cap = window.Capacitor;
      if (!cap || typeof cap.isNativePlatform !== 'function' || !cap.isNativePlatform()) return null;
      const plugin = cap.Plugins && cap.Plugins.App;
      if (!plugin || typeof plugin.getInfo !== 'function') return null;
      const info = await plugin.getInfo();
      return info && info.version ? String(info.version) : null;
    } catch {
      return null;
    }
  }

  async readBinaryRequirement() {
    if (!Version.minBinary) return false;
    const binary = await this.installedBinaryVersion();
    if (!binary) return false;
    return compareVersions(binary, Version.minBinary) < 0;
  }

  async updateVersion(apiVersion) {
    if (this.binaryBehind || await this.binaryIsBehind()) {
      this.updateRequired = true;
      this.emitStateUpdate();
      return;
    }

    const clientSide = parseVersion(Version.version);
    const serverSide = parseVersion(apiVersion);
    const needsUpgrade = serverSide.length === 3 && clientSide.length === 3
      && (serverSide[0] > clientSide[0]
        || (serverSide[0] === clientSide[0] && serverSide[1] > clientSide[1]));

    if (!needsUpgrade) {
      if (!this.binaryBehind) this.updateRequired = false;
      sessionStorage.removeItem('logictry_version_reload');
      this.emitStateUpdate();
      return;
    }

    if (Constants.isIphone && serverSide[0] > clientSide[0]) {
      this.updateRequired = true;
      this.emitStateUpdate();
      return;
    }

    try {
      if (Constants.isIphone) {
        const vRes = await fetch(`https://logictry.com/version.json`, {
          cache: 'no-store',
          credentials: 'omit',
        });
        if (!vRes.ok) throw new Error();
        const published = (await vRes.json()).version;
        if (!published) throw new Error();

        const zRes = await fetch(`https://logictry.com/mobile/version.json`, {
          cache: 'no-store',
          credentials: 'omit',
        });
        if (!zRes.ok) throw new Error();
        const zResVersion = (await zRes.json()).version;
        if (!zResVersion) throw new Error();

        if (zResVersion !== published) throw new Error();
      }

      this.reloadForNewVersion();
    } catch {
      //
    }
  }
}
const singleton = new VersionChecker();
export default singleton;
